/**
 * @file 変更ログ用ページ
 * @description 予定承認表ページ用スクリプト
 * @author lincrea.co.jp
 * @version 1.0.0
 */
import *  as _ from "lodash";
import { wijmo, wjcInput } from "../../grapecity";
import * as SPIRIT from "../../SPIRIT";

// パラメータ
export type PARAMETER = any[];

/**
 * 変更ログモーダル
 */
export class PasswordChangeModal extends SPIRIT.base.ModalBase {

    // ツールチップ
    private tooltip;

    // 「OK」ボタンエレメント
    private btnOk: JQuery<HTMLElement>;
    UserName: string;
    MailAddress: string;
    password: wjcInput.ComboBox;
    passwordText: string;
    newPassword: wjcInput.ComboBox;
    newPasswordConfirm: wjcInput.ComboBox;
    btnCancel: JQuery<HTMLElement>;
    IsAdminUser: boolean;
    PasswordReuseEnableFlg: boolean;
    IsNeedChangePasssword: boolean;
    btnDismiss: JQuery<HTMLElement>;


    /**
     * コンストラクタ
     * @param mode 画面モード
     * @param param パラメータ
     */
    constructor(UserName: string, MailAddress: string, password?: string, isNeedChangePasssword: boolean = false, param?: PARAMETER) {
        //#2587 閉じれないモーダル(dissmissがない)で、ESCkey押下で閉じれてしまう
        //super(param);
        //#4346
        //super(param, true, true);
        super(param, true, (isNeedChangePasssword) ? true : false);

        this.UserName = UserName;
        this.MailAddress = MailAddress;
        this.passwordText = password;
        //#4346
        this.IsNeedChangePasssword = isNeedChangePasssword;
    }

    /**
     * 描画するレイアウトの取得
     */
    private loadLayout() {
        return new Promise<any>((resolve, reject) => {
            SPIRIT.util.ajax({
                url: '/Account/GetPassowrdChangeModalLayout',
                type: 'GET',
            }).done(function (data) {
                resolve(data)
            });
        });
    }

    /**
     * コンテンツの作成
     */
    protected initialize(resolve, reject) {
        // 描画するレイアウトの取得
        this.loadLayout().then(_elem => {
            // モーダル
            const modal = $(_elem);
            resolve(modal);
        });
    }


    /**
     * 初期表示コンテンツの作成
     */
    protected build(resolve, reject) {

        const modal = $(this.content);
        // debugger;
        $("#UserName", modal).text(this.UserName);
        $("#MailAddress", modal).text(this.MailAddress);

        ////現在のパスワード
        this.password = new wjcInput.ComboBox($('#password', modal), { inputType: 'password', isRequired: true });
        //this.password.hostElement.setAttribute('autocomplete', 'new-password');

        //新しいパスワード
        this.newPassword = new wjcInput.ComboBox($('#newPassword', modal), { inputType: 'password', isRequired: true });

        //※注意　別の方式を考えるか！
        //自動補完を無効にすると、 WCAG 2.1 の 1.3.5: Identify Input Purpose の規則を破ることになることを知っておくことが重要です。 WCAG に従うウェブサイトを制作するのであれば、自動的に記入する自動補完を使用するべきです。
        this.newPassword.inputElement.setAttribute('autocomplete', 'new-password');


        //新しいパスワード(※確認)
        this.newPasswordConfirm = new wjcInput.ComboBox($('#newPasswordConfirm', modal), { inputType: 'password', isRequired: true });
        //※注意　別の方式を考えるか！
        //自動補完を無効にすると、 WCAG 2.1 の 1.3.5: Identify Input Purpose の規則を破ることになることを知っておくことが重要です。 WCAG に従うウェブサイトを制作するのであれば、自動的に記入する自動補完を使用するべきです。
        this.newPasswordConfirm.inputElement.setAttribute('autocomplete', 'new-password');


        //ボタンインスタンス保持
        this.btnOk = $('#btn_apply', modal);
        this.btnCancel = $('#btn_cancel', modal);

        //#4346
        this.btnDismiss = $('#btn_dismiss', modal);

        if (this.IsNeedChangePasssword) {
            this.btnCancel.addClass('d-none');
            this.btnDismiss.addClass('d-none');
        } else {
            this.btnCancel.removeClass('d-none');
            this.btnDismiss.addClass('d-none');
        }


        //toolTip
        this.setToolTip();

        resolve();
    }

    /**
     * ツールチップをセット
     */
    setToolTip() {
        this.tooltip = new wijmo.Tooltip({});
        this.tooltip.setTooltip(this.btnOk.get(0), 'OK');
        this.tooltip.setTooltip(this.btnCancel.get(0), 'Cancel');
    }

    /**
     * イベントをセット
     */
    //protected setEvent() {
    protected setEvent(resolve, reject) {
        //super.setEvent();

        //let form = $(".modal-content").find('input');
        //保存
        this.btnOk.on('click', (e) => {

            var isError = false;

            if ($("#password_input").val() == "") {
                $("#password").addClass("wj-state-empty");
                $("#password").addClass("wj-state-invalid");

                isError = true;
            }

            if ($("#newPassword_input").val() == "") {
                $("#newPassword").addClass("wj-state-empty");
                $("#newPassword").addClass("wj-state-invalid");
                isError = true;
            }

            if ($("#newPasswordConfirm_input").val() == "") {
                $("#newPasswordConfirm").addClass("wj-state-empty");
                $("#newPasswordConfirm").addClass("wj-state-invalid");
                isError = true;
            }

            if (isError) {
                SPIRIT.notify.error(SPIRIT.util.getMessage(SPIRIT.message.MSG_E_00002));
                SPIRIT.loading.hide()
                return false;
            }

            // 保存データ
            const form = {
                Password: $("#password_input").val(),
                NewPassword: $("#newPassword_input").val(),
                NewPasswordConfirm: $("#newPasswordConfirm_input").val(),

            };

            SPIRIT.util.ajax({
                url: '/Account/PasswordChangeValidation',
                type: 'POST',
                data: form,
                //dataType: 'json',
            }).done(function (res) {
                res = JSON.parse(res) || {};
                if (res.IsError) {
                    for (let message of res.Data) {
                        SPIRIT.notify.error(message);
                    }
                    return;
                }
                SPIRIT.util.ajax({
                    url: '/Account/PasswordChange',
                    type: 'POST',
                    data: form,
                }).done(function (res) {
                    //res = JSON.parse(res) || {};
                    //cb(res);
                    SPIRIT.notify.success(SPIRIT.util.getMessage(SPIRIT.message.MSG_I_00013));
                    //wj-hide-okクラスが入ってれば自動で消えるので、下記はいらない
                    //modalElement.close();
                    //明示的にOKを返す
                    modalElement.close('ok');
                });

            });

            const modalElement = this;
        });

        //キャンセル
        this.btnCancel.on('click', (e) => {
            //wj-hide-cancelクラスが入ってれば自動で消えるので、下記はいらない
            //this.close();
            //明示的にcancelを返す
            this.close('cancel');
        });

        resolve();
    }
}
